import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Button as MuiButton, useTheme } from '@mui/material';
import BmrclMetroStationImg from '@/asset/bmrcl_metro_station.jpg';

export const ProjectsSection: React.FC = () => {
  const theme = useTheme();
  const [selectedFilter, setSelectedFilter] = useState('All');
  const isDark = theme.palette.mode === 'dark';

  const filters = ['All', 'Commercial', 'Residential', 'Institutional', 'Infrastructure'];

  const projects = [
    {
      title: 'Brigade Commercial Hub',
      category: 'Commercial Hub',
      location: 'Whitefield, Bengaluru',
      filterTag: 'Commercial',
      image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=1000&auto=format&fit=crop',
    },
    {
      title: 'SAP Labs Campus',
      category: 'Campus Infrastructure',
      location: 'ITPL, Bengaluru',
      filterTag: 'Institutional',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=1000&auto=format&fit=crop',
    },
    {
      title: 'BMRCL Infrastructure',
      category: 'Metro Corridor',
      location: 'Metro Corridor, Bengaluru',
      filterTag: 'Infrastructure',
      image: BmrclMetroStationImg,
    },
  ];

  const filteredProjects = selectedFilter === 'All'
    ? projects
    : projects.filter((p) => p.filterTag === selectedFilter);

  return (
    <Box
      id="projects"
      sx={{
        py: { xs: 10, md: 14 },
        backgroundColor: isDark ? 'rgba(22, 29, 47, 0.3)' : '#f1f5f9',
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2rem', md: '2.75rem' },
              color: theme.palette.text.primary,
              fontFamily: 'Space Grotesk',
              fontWeight: 700,
              mb: 3,
            }}
          >
            Proven Project Excellence
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1.5 }}>
            {filters.map((filter) => {
              const active = selectedFilter === filter;
              return (
                <MuiButton
                  key={filter}
                  onClick={() => setSelectedFilter(filter)}
                  sx={{
                    borderRadius: 50,
                    px: 3,
                    py: 0.75,
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    backgroundColor: active
                      ? theme.palette.primary.main
                      : isDark ? 'transparent' : '#ffffff',
                    color: active
                      ? '#ffffff'
                      : theme.palette.text.primary,
                    border: active
                      ? `1px solid ${theme.palette.primary.main}`
                      : `1px solid ${theme.palette.divider}`,
                    boxShadow: !active && !isDark ? '0 1px 4px rgba(0, 0, 0, 0.05)' : 'none',
                    '&:hover': {
                      backgroundColor: active
                        ? theme.palette.primary.dark
                        : isDark ? 'rgba(255, 255, 255, 0.08)' : '#e2e8f0',
                    },
                  }}
                >
                  {filter}
                </MuiButton>
              );
            })}
          </Box>
        </Box>

        <Grid container spacing={4}>
          {filteredProjects.map((project, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box
                sx={{
                  position: 'relative',
                  height: 450,
                  borderRadius: 2,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  border: `1px solid ${theme.palette.divider}`,
                  boxShadow: isDark ? 'none' : '0 8px 30px rgba(0, 0, 0, 0.08)',
                  transition: 'transform 0.5s ease, border-color 0.5s ease',
                  '&:hover': {
                    borderColor: theme.palette.primary.main,
                    '& .bg-img': {
                      transform: 'scale(1.1)',
                    },
                  },
                }}
              >
                <Box
                  className="bg-img"
                  sx={{
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url('${project.image}')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    transition: 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(to top, rgba(11, 15, 25, 0.9) 0%, rgba(11, 15, 25, 0.2) 60%, transparent 100%)',
                  }}
                />
                <Box sx={{ position: 'absolute', bottom: 0, left: 0, p: 4, width: '100%' }}>
                  <Typography
                    variant="caption"
                    sx={{ color: '#40c2fd', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', mb: 0.5 }}
                  >
                    {project.category}
                  </Typography>
                  <Typography variant="h5" sx={{ color: '#ffffff', fontFamily: 'Space Grotesk', fontWeight: 700, mb: 0.5 }}>
                    {project.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
                    {project.location}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ProjectsSection;
